export default "__VITE_ASSET__0dede21e__"